import React, { Component } from "react";

function Footer(props) {
  return (
    <div className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-6">
            <p>{props.name}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
